export default __webpack_public_path__ + "143b68a4324180ff99d55a6ed93c8c54.gif";